module.exports = __webpack_public_path__ + "static/media/shopping-cart.0faf4c4c.svg";